/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import html2canvas from 'html2canvas';
import { jsPDF as JsPDF } from 'jspdf';
import { Form, Modal, Table, TableProps, TableColumnType, Button } from 'antd';

import { type TEvidenceDetail } from '../schema';

const defaultColumnOptions: TableColumnType<any> = {
  align: 'center',
  render: (value) => {
    if (typeof value === 'number') return value ? Number(value).toLocaleString() : 0;
    return value || '-';
  }
};
export const columns1: TableProps<any>['columns'] = [
  { title: '작성일자', dataIndex: 'writeDate', width: '18%', ...defaultColumnOptions },
  { title: '공급가액', dataIndex: 'supplyAmount', width: '18%', ...defaultColumnOptions },
  { title: '세액', dataIndex: 'vatAmount', width: '18%', ...defaultColumnOptions },
  { title: '합계금액', dataIndex: 'totalAmount', width: '18%', ...defaultColumnOptions },
  { title: '수정사유', dataIndex: 'correctionReason', width: '18%', ...defaultColumnOptions },
  { title: '비고', dataIndex: 'name', width: '10%', ...defaultColumnOptions }
];
export const columns2: TableProps<any>['columns'] = [
  {
    title: '월',
    dataIndex: 'writeDate',
    width: '5%',
    ...defaultColumnOptions,
    render: (value) => (value ? moment(value).month() + 1 : '-')
  },
  {
    title: '일',
    dataIndex: 'writeDate',
    width: '5%',
    ...defaultColumnOptions,
    render: (value) => (value ? moment(value).date() : '-')
  },
  { title: '품목', dataIndex: 'itemName', width: '20%', ...defaultColumnOptions },
  { title: '수량', dataIndex: 'quantity', width: '8%', ...defaultColumnOptions },
  { title: '단가', dataIndex: 'unitPrice', width: '18%', ...defaultColumnOptions },
  { title: '공급가액', dataIndex: 'supplyAmount', width: '18%', ...defaultColumnOptions },
  { title: '세액', dataIndex: 'vatAmount', width: '18%', ...defaultColumnOptions }
];

const AntdModal = styled(Modal)`
  .ant-modal-header {
    padding: 14px 24px 12px;
    .ant-modal-title {
      font-size: 22px;
      font-weight: 700;
    }
  }
`;
const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: 700;
  color: #6d7582;
  button {
    width: 80px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
  }
`;

export const EvidenceContainer = styled.div`
  display: table;
  width: 100%;
  border-collapse: collapse;

  & > div {
    display: table-cell;
  }
`;

export const EvidenceHeaderContainer = styled(EvidenceContainer)`
  .asdasd .ant-form-item-row {
    /* max-width: 252.17px; */
    /* width: 100%; */
  }
  && .ant-form .ant-form-item .ant-form-item-label {
    /* .ant-form-item-label { */
    & > label {
      font-size: 16px;
      font-weight: 700;
      color: #000000;
    }
  }
`;

export const EvidenceFormWrapper = styled.div`
  border: 1px solid #e2e2e2;
  border-top: none;

  .display-flex {
    width: 100%;
    display: flex;
  }
  .target {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;
    padding: 0 10px;
    text-align: center;
    font-weight: 700;
    background: #f7f7f7;
    /* border: 1px solid #e2e2e2; */
  }
  .maxWidth-item .ant-form-item-control {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    max-width: 147px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .ant-form {
    width: 100%;
    .ant-form-item {
      flex: 1;
      margin: 0;
      .ant-form-item-label {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        height: 40px;
        min-height: 50px;
        background: #f7f7f7;
        border: 1px solid #e2e2e2;
        border-left: none;
        border-bottom: none;

        label {
          margin: 0;
          text-align: center;
          white-space: pre-wrap;
          font-size: 14px;
          font-weight: 700;
          line-height: 16px;
          color: #353c49;
        }
        label:after {
          display: none;
        }
      }
      .ant-form-item-label .ant-form-item-label label:after {
        display: none;
      }
      .ant-form-item-control {
        /* width: 100%; */
        display: flex;
        align-items: flex-start;
        justify-content: center;
        /* max-width: 147px; */
        padding: 0 10px;
        background: #ffffff;
        border-top: 1px solid #e2e2e2;
      }
    }
  }
`;

export const EvidenceTableContainer = styled.div`
  .ant-table-content {
    & > table {
      border-collapse: collapse;

      .ant-table-thead {
        .ant-table-cell {
          height: 50px;
          background: #f7f7f7;
          border: 1px solid #e2e2e2;
          border-top: none;
          font-size: 14px;
          font-weight: 700;
          line-height: 16px;
        }
      }
      .ant-table-tbody {
        .ant-table-cell {
          border: 1px solid #e2e2e2;
        }
      }
    }
  }
`;
// {/* 줄바꿈으로 인한 UI 깨짐 방지 */}
const EvidenceForm = ({ title, data }: { title: string; data: any }) => (
  <EvidenceFormWrapper style={{ width: '50%' }}>
    <div className="target">{title}</div>
    <Form>
      <Form.Item label="등록번호">{data?.bizNumber}</Form.Item>
      <Form.Item label="상호명">{data?.bizName}</Form.Item>
      <Form.Item label="대표자명">{data?.bizPresidentName}</Form.Item>
      <Form.Item label="사업장 주소">{data?.bizAddress}</Form.Item>
      <Form.Item label="업태">{data?.bizCategory}</Form.Item>
      <Form.Item label="종목">{data?.bizItem}</Form.Item>
      <div className="display-flex">
        <Form.Item label="이메일">{data?.bizEmail?.map((value) => <div>{value || '-'}</div>)}</Form.Item>
      </div>
    </Form>
  </EvidenceFormWrapper>
);

interface EvidenceDetailModalProps {
  open: boolean;
  evidenceData?: TEvidenceDetail;
  onCancel?: () => void;
}

const EvidenceTaxInvoiceModal = ({ open, evidenceData, onCancel }: EvidenceDetailModalProps) => {
  const handlePDFDownload = async () => {
    const content = document.getElementById('pdf');
    if (!content) return;

    const canvas = await html2canvas(content, {
      scale: 2,
      backgroundColor: '#FFFFFF',
      useCORS: true,
      windowWidth: content.scrollWidth,
      windowHeight: content.scrollHeight,
      scrollX: 0,
      scrollY: -window.scrollY
    });

    const fileName = `증빙 상세_${moment().valueOf()}`;
    const doc = new JsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4', compress: true });

    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const margin = 5;
    const maxW = pageW - margin * 2;
    const maxH = pageH - margin * 2;

    const ratio = Math.min(maxW / canvas.width, maxH / canvas.height);
    const renderW = canvas.width * ratio;
    const renderH = canvas.height * ratio;
    const x = (pageW - renderW) / 2;
    const y = (pageH - renderH) / 2;

    const img = canvas.toDataURL('image/jpeg', 0.92);
    doc.addImage(img, 'JPEG', x, y, renderW, renderH, undefined, 'MEDIUM');
    doc.save(`${fileName}.pdf`);
  };

  const provider = {
    bizNumber: evidenceData?.providerBizNumber || '-',
    bizSubNumber: evidenceData?.providerBizSubNumber || '-',
    bizName: evidenceData?.providerBizName || '-',
    bizPresidentName: evidenceData?.providerBizPresidentName || '-',
    bizAddress: evidenceData?.providerAddress || '-',
    bizCategory: evidenceData?.providerBizCategory || '-',
    bizItem: evidenceData?.providerBizItem || '-',
    bizEmail: [evidenceData?.providerEmail]
  };
  const receiver = {
    bizNumber: evidenceData?.receiverBizNumber || '-',
    bizSubNumber: evidenceData?.receiverBizSubNumber || '-',
    bizName: evidenceData?.receiverBizName || '-',
    bizPresidentName: evidenceData?.receiverBizPresidentName || '-',
    bizAddress: evidenceData?.receiverAddress || '-',
    bizCategory: evidenceData?.receiverBizCategory || '-',
    bizItem: evidenceData?.receiverBizItem || '-',
    bizEmail: evidenceData?.receiverEmail2
      ? [evidenceData?.receiverEmail1, evidenceData?.receiverEmail2]
      : [evidenceData?.receiverEmail1]
  };
  return (
    <AntdModal
      title="증빙 상세"
      width={1000}
      open={open}
      onCancel={onCancel}
      footer={
        <ModalFooter>
          <Button type="primary" style={{ width: '120px' }} onClick={handlePDFDownload}>
            PDF 다운로드
          </Button>
          <Button onClick={onCancel}>닫기</Button>
        </ModalFooter>
      }
    >
      <div id="pdf">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '40px',
            padding: '0px 16px',
            border: '1px solid #e2e2e2'
          }}
        >
          <div style={{ fontWeight: '700' }}>{evidenceData?.evidenceTypeName || '-'}</div>
          <div style={{ fontWeight: '500' }}>승인번호 : {evidenceData?.confirmNumber || '-'}</div>
        </div>
        <EvidenceContainer>
          <EvidenceForm title="공급자" data={provider} />
          <EvidenceForm title="공급받는자" data={receiver} />
        </EvidenceContainer>
        <EvidenceTableContainer>
          <Table columns={columns1} dataSource={[evidenceData]} pagination={false} />
          <Table columns={columns2} dataSource={evidenceData?.evidenceItems || [null]} pagination={false} />
        </EvidenceTableContainer>
      </div>
    </AntdModal>
  );
};

export default EvidenceTaxInvoiceModal;
